import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import styles from "./ModalWindow.module.css";

function ModalWindow({ setShow, show, idBoadCard }) {
  const navigate = useNavigate();
  const pathName = window.location.pathname;
  const dispatch = useDispatch();
  const [key, setKey] = useState("");

  const buttonsNames = {
    leftBtnText: (() => {
      switch (true) {
        case window.location.pathname.includes("exchange-certificates") ||
          window.location.pathname.includes("duplicate-certificates"):
          return "Республиканское";
        default:
          return "Физическое лицо";
      }
    })(),
    rightBtnText: (() => {
      switch (true) {
        case window.location.pathname.includes("exchange-certificates") ||
          window.location.pathname.includes("duplicate-certificates"):
          return "Международное";
        default:
          return "Юридическое лицо";
      }
    })(),
  };

  const buttonsKeys = {
    leftBtnKey: (() => {
      switch (true) {
        case window.location.pathname.includes("exchange-certificates") ||
          window.location.pathname.includes("duplicate-certificates"):
          return "republican";
        default:
          return "individual";
      }
    })(),
    rightBtnKey: (() => {
      switch (true) {
        case window.location.pathname.includes("exchange-certificates") ||
          window.location.pathname.includes("duplicate-certificates"):
          return "international";
        default:
          return "entity";
      }
    })(),
  };

  const titleText = (() => {
    switch (true) {
      case window.location.pathname.includes("transportaccidents"):
        return "Выбор вида судовладельца";
      case window.location.pathname.includes("exchange-certificates") ||
        window.location.pathname.includes("duplicate-certificates"):
        return "Тип удостоверения";
      default:
        return "Выбор вида заявителя";
    }
  })();

  const handleBtnClick = (e) => {
    if (e.currentTarget.dataset.key === key) {
      setKey("");
    } else setKey(e.currentTarget.dataset.key);
  };

  const handleChooseClick = (e) => {
    switch (true) {
      case pathName.includes("smallboatsreg"):
        switch (key) {
          case "individual":
            navigate("/smallboatsreg/app/individual", {
              state: { type: "individual", mode: "add" },
            });
            break;
          case "entity":
            navigate("/smallboatsreg/app/entity", {
              state: { type: "entity", mode: "add" },
            });
            break;
          default:
            break;
        }
        break;
      case pathName.includes("provisioninformation"):
        let idTypeStatement = null;
        switch (key) {
          case "individual":
            idTypeStatement = 1;
            navigate("/provisioninformation/individual/add", {
              state: { idTypeStatement },
            });
            break;
          case "entity":
            idTypeStatement = 2;
            navigate("/provisioninformation/entity/add", {
              state: { idTypeStatement },
            });
            break;
          default:
            break;
        }
        break;
      case pathName.includes("exchange-certificates"):
        switch (key) {
          case "republican":
            navigate("/exchange-certificates/add/republican");
            break;
          case "international":
            navigate("/exchange-certificates/add/international");
            break;
          default:
            break;
        }
        break;
      case pathName.includes("duplicate-certificates"):
        switch (key) {
          case "republican":
            navigate("/duplicate-certificates/add/republican");
            break;
          case "international":
            navigate("/duplicate-certificates/add/international");
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }
  };

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header
        closeButton
        className={styles["form-header"]}>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={styles["form-title"]}>
          {titleText}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles["form-body"]}>
        <nav className={styles["buttons-block"]}>
          <div
            className={key === buttonsKeys?.leftBtnKey ? styles["active-btn"] : ""}
            onClick={(e) => handleBtnClick(e)}
            data-key={buttonsKeys.leftBtnKey}>
            {buttonsNames.leftBtnText}
          </div>
          <div
            className={key === buttonsKeys?.rightBtnKey ? styles["active-btn"] : ""}
            onClick={(e) => handleBtnClick(e)}
            data-key={buttonsKeys.rightBtnKey}>
            {buttonsNames.rightBtnText}
          </div>
        </nav>
      </Modal.Body>
      <Modal.Footer className={styles["form-footer"]}>
        <button
          className={styles["save-btn"]}
          onClick={(e) => handleChooseClick(e)}>
          Выбрать
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalWindow;
